<template>
    <tailwind-table     :data="usersData"
                        :exportable="false"
                        :headers="headers"
                        :rows-with-errors="rowsWithErrors"
    >
        <!-- First Name Edit -->
        <template  #col-1="props">
            <div    class="flex flex-col">
                <span   v-if="fieldHasError(props.row, 'first_name')">{{ fieldErrorMessage(props.row, 'first_name') }}</span>
                <floating-input     v-model:value="props.row.first_name"
                                    :name="`first_name_${props.row.index}`"
                                    label="First Name"></floating-input>
            </div>
        </template>

        <!-- Last Name Edit -->
        <template  #col-2="props">
            <div    class="flex flex-col">
                <span   v-if="fieldHasError(props.row, 'last_name')">{{ fieldErrorMessage(props.row, 'email') }}</span>
                <floating-input     v-model:value="props.row.last_name"
                                    :name="`last_name_${props.row.index}`"
                                    label="last Name"></floating-input>
            </div>
        </template>

        <!-- Email Edit -->
        <template  #col-3="props">
            <div    class="flex flex-col">
                <span   v-if="fieldHasError(props.row, 'email')">{{ fieldErrorMessage(props.row, 'email') }}</span>
                <floating-input     v-model:value="props.row.email"
                                    :name="`email_${props.row.index}`"
                                    label="Email"></floating-input>
            </div>
        </template>

        <!-- Role Edit -->
        <template  #col-4="props">
            <div    class="flex flex-col w-full">
                <span   v-if="fieldHasError(props.row, 'role')">{{ fieldErrorMessage(props.row, 'role') }}</span>
                <select2    v-model:value="props.row.role"
                            :name="`role_${props.row.index}`"
                            class="w-full"
                            :close-on-select="true"
                            :options="roles"
                            label="Role"></select2>
            </div>
        </template>

        <!-- Phone Number Edit -->
        <template  #col-5="props">
            <div    class="flex flex-col">
                <span   v-if="fieldHasError(props.row, 'phone_number')">{{ fieldErrorMessage(props.row, 'phone_number') }}</span>
                <floating-input     v-model:value="props.row.phone"
                                    :name="`phone_number_${props.row.index}`"
                                    label="Phone Number"></floating-input>
            </div>
        </template>

        <!-- Company -->
        <template  #col-6="props">
            <div    class="flex flex-col w-full">
                <span   v-if="fieldHasError(props.row, 'company_id')">{{ fieldErrorMessage(props.row, 'company_id') }}</span>
                <select2    v-model:value="props.row.company_id"
                            :close-on-select="true"
                            :name="`company_${props.row.index}`"
                            :options="companies"
                            class="w-full"
                            label="Company"></select2>
            </div>
        </template>
    </tailwind-table>
</template>

<script>
import _ from "lodash"

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import TailwindTable from "@/components/elements/TailwindTable.vue";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck.vue";
import FloatingInput from "@/components/elements/FloatingInput.vue";
import Select2 from "@/components/elements/select2.vue";

export default {
    name: "ImportUsersValidateCsv",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Select2, FloatingInput, SmallColoredCheck, TailwindTable},
    emits: [],
    props: {
        usersData: {
            type: Array,
            required: true,
        },
        roles: {
            type: Object,
            required: true,
        },
        companies: {
            type: Object,
            required: true,
        },
        rowsWithErrors: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            // Headers
            headers: [
                {
                    name: 'First Name',
                    key: 'first_name',
                },
                {
                    name: 'Last Name',
                    key: 'last_name',
                },
                {
                    name: 'Email',
                    key: 'email',
                },
                {
                    name: 'Role',
                    key: 'role',
                },
                {
                    name: 'Phone Number',
                    key: 'phone_number',
                },
                {
                    name: 'Company ID',
                    key: 'company_id',
                },
            ],
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        fieldHasError(row, field) {
            // The key for field exists on row.errors, it is not null, and it is not an empty string
            return _.has(row['errors'], field) && ! _.isNil(row.errors[field]) && row.errors[field].length !== ''
        },
        fieldErrorMessage(row, field) {
            return row.errors[field]
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>